import React, { useEffect, useState } from "react";
import CardLayout, {
  CardLayoutContainerProps,
} from "components/foundation/templates/CardLayout";
import styled, { css } from "styled-components";
import useMediaView from "features/common/hooks/useMediaView";

interface AuthBottomSheetLayoutProps extends CardLayoutContainerProps {
  bottomWithKeyboard?: number;
}

const AuthBottomSheetLayout = ({
  bottomWithKeyboard,
  children,
  ...rest
}: AuthBottomSheetLayoutProps) => {
  /* 키보드에 따라 fixed bottom 높이 조절 */
  const [bottom, setBottom] = useState(0);
  const [viewportHeight, setViewportHeight] = useState(window.innerHeight);

  const isSmallView = useMediaView("small");

  useEffect(() => {
    const handleResize = () => {
      const newViewportHeight = window.innerHeight;

      // 키보드가 열렸는지 여부를 판단 (뷰포트가 작아지면 키보드 열림)
      if (newViewportHeight < viewportHeight) {
        setBottom(bottomWithKeyboard || 0); // 키보드가 열렸을 때
      } else {
        setBottom(0); // 키보드가 닫혔을 때
      }

      setViewportHeight(newViewportHeight); // 현재 뷰포트 높이 저장
    };

    // 브라우저 resize 이벤트 리스너 추가
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [viewportHeight]);

  return (
    <CardLayoutStyle
      {...rest}
      gap={isSmallView ? 24 : undefined}
      style={{
        bottom: `${bottom / 10}rem`,
      }}
    >
      {children}
    </CardLayoutStyle>
  );
};

export default AuthBottomSheetLayout;

/* 스타일 */
const CardLayoutStyle = styled(CardLayout.Container)`
  ${({ theme }) => css`
    ${theme.media.small} {
      width: 100%;
      padding: 3rem 1.6rem 8rem 1.6rem;

      position: fixed;
      bottom: 0;
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
      transition: bottom 0.3s ease;
    }
  `}
`;
